import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import { CheckMarkIcon, ListApprovedIcon, TestSuccessIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useLanguageTest from '../../../../views/client-personal-space/informations/context/use-language-test'
import { ClientHeader } from './shared-client-space-ui'

const LanguageTestSubmitted = () => {
  const { currentActiveSubmission } = useLanguageTest()

  return (
    <Box className="space-y-5 mobile:pb-0 mobile:px-0">
      <ClientHeader title={'Test de niveau'} icon={ListApprovedIcon} />

      {currentActiveSubmission?.hasAutoSubmitted && (
        <div className="bg-red-light rounded p-2 flex items-center gap-2">
          <Typography variant="tag" color={tailwindColors.red.DEFAULT}>
            Temps écoulé, le test a été automatiquement transmis à LEC.
          </Typography>
        </div>
      )}

      <div className="bg-green-light rounded p-2 flex items-center gap-2">
        <div className="border border-green-light-active rounded-full p-px w-fit">
          <CheckMarkIcon color={tailwindColors.green.DEFAULT} className="w-4 h-4" />
        </div>
        <Typography variant="tag" color={tailwindColors.green.DEFAULT}>
          Merci, nous avons bien reçu votre test.
        </Typography>
      </div>

      <div className="flex items-center justify-center">
        <TestSuccessIcon className="mobile:h-56" />
      </div>
    </Box>
  )
}

export default LanguageTestSubmitted
